<template>
  <div class="container">
    <financial-record-datatable :module_settings="module_settings" />
  </div>
</template>

<script>
import FinancialRecordDatatable from "./financial_record_datatable/Index.vue";
import { get_configuration } from "@/utils";

export default {
  name: "FinancialRecordIndex",
  components: { FinancialRecordDatatable },
  data() {
    return {
      is_loading: false,
      module_settings: {},
    };
  },
  methods: {
    retrieve_settings() {
      get_configuration(this)
        .then((conf) => {
          this.module_settings = conf;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  mounted() {},
  created() {
    let v = this;
    v.retrieve_settings();
  },
};
</script>

<style scoped></style>
